import {
  GETKYBDETAILSLIST_SUCCESS,
  GETKYBDETAILSLIST_FAILED,
  RESET_GETKYBDETAILSLIST,
  LOADING_GETKYBDETAILSLIST,
  NETWORK_ERROR_GETKYBDETAILSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETKYBDETAILSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETKYBDETAILSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETKYBDETAILSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETKYBDETAILSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETKYBDETAILSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
